<div class="kpi-container">
  <div class="kpi-header">
    <div class="title-section">
      <h2>Owner Performance KPIs</h2>
      <p class="subtitle">Key metrics breakdown for {{ selectedYear }}</p>
    </div>
    
    <div class="filters">
      <div class="filter-group">
        <label for="yearSelect">Year</label>
        <select id="yearSelect" [(ngModel)]="selectedYear" (change)="onFilterChange()">
          <option *ngFor="let year of years" [value]="year">{{ year }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="loading-container" *ngIf="loading">
    <div class="spinner"></div>
  </div>

  <div class="kpi-sections-row" *ngIf="!loading">
    <div class="kpi-section" *ngFor="let group of allKpiData">
    <h3 class="kpi-section-title">
      <span>{{ group.label }}</span>
    </h3>
    <div class="kpi-grid">
    <div class="stat-card" *ngFor="let item of group.items">
      <div class="stat-title">
        <ng-container *ngIf="group.type === 'profit'; else defaultName">
          <select [(ngModel)]="selectedOwnerId" (change)="onFilterChange()" class="owner-select">
            <option value="" *ngIf="isAdminOrSuperAdmin">All Owners</option>
            <option *ngFor="let owner of owners" [value]="owner.id">{{ owner.name }}</option>
          </select>
        </ng-container>
        <ng-template #defaultName>{{ item.name }}</ng-template>

        <span class="trend-indicator" [style.color]="item.trend === 'up' ? '#16a34a' : (item.trend === 'down' ? '#dc2626' : '#94a3b8')" *ngIf="item.trend && item.trend !== 'neutral'">
          {{ item.trend === 'up' ? '▲' : '▼' }}
        </span> 
      </div>
      <div class="stat-value" [ngClass]="{'success': group.type === 'collection_rate', 'danger': group.type === 'expense' || group.type === 'fee'}">
        <ng-container *ngIf="group.type === 'collection_rate'; else numericValue">
          {{ item.value | percent:'1.0-2' }}
        </ng-container>
        <ng-template #numericValue>
          <ng-container *ngIf="group.type === 'expense' || group.type === 'fee'; else standardCurrency">
            ({{ item.value | currency:'USD':'symbol':'1.0-0' }})
          </ng-container>
          <ng-template #standardCurrency>
            {{ item.value | currency:'USD':'symbol':'1.0-0' }}
          </ng-template>
        </ng-template>
      </div>
      <div class="progress-bar-bg" *ngIf="group.type === 'collection_rate'">
        <div class="progress-bar-fill success" [style.width.%]="item.value * 100"></div>
      </div>
      <div class="stat-sub" *ngIf="item.details">{{ item.details }}</div>
    </div>
    </div>
    </div>
  </div>
  
  <div class="no-data" *ngIf="!loading && allKpiData.length === 0">
    <p>No data available for the selected criteria.</p>
  </div>
</div>